import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft, ArrowRight, Settings } from 'lucide-react';
import { Button } from './ui/button';

const AdminPreviewNav = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Only show if user is logged in as admin
  if (!user) return null;

  // Only show on homepage or settings page
  const isHomepage = location.pathname === '/';
  const isSettings = location.pathname === '/admin/settings';

  if (!isHomepage && !isSettings) return null;

  return (
    <div className="fixed bottom-8 right-8 z-50">
      <div className="bg-white rounded-xl shadow-2xl border-2 border-sage-300 p-4">
        {isSettings && (
          <Button
            onClick={() => navigate('/')}
            className="bg-sage-700 hover:bg-sage-800 text-white"
          >
            <ArrowRight className="mr-2 h-4 w-4" />
            Preview Homepage
          </Button>
        )}
        {isHomepage && (
          <Button
            onClick={() => navigate('/admin/settings')}
            className="bg-sage-700 hover:bg-sage-800 text-white"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Settings
          </Button>
        )}
        <div className="text-xs text-gray-600 text-center mt-2">
          Admin Preview Mode
        </div>
      </div>
    </div>
  );
};

export default AdminPreviewNav;
